import { render } from "./RecyclePage.vue?vue&type=template&id=58fedd74"
import script from "./RecyclePage.vue?vue&type=script&lang=js"
export * from "./RecyclePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__